export default __webpack_public_path__ + "static/media/new-image.deee0fcc.png";